( function() {
    'use strict';

    angular.module('SmartAdmin.Forms').directive('smartEditSummernote', function () {
        return {
            restrict: 'A',
            compile: function (tElement, tAttributes) {
                tElement.removeAttr('smart-edit-summernote data-smart-edit-summernote');
                tElement.on('click', function(){
                    angular.element(tAttributes.smartEditSummernote).summernote({
                        focus : true
                    });
                });
            }
        }
    });

})();
